// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ui-recommendation-header.css */
.ant-typography{
  font-family: "Poppins" !important;
}

.ui-recommendation-header {
  display: flex;
  align-items: center;
  padding: 0.5rem 1rem;
  border-radius: 8px 8px 0px 0px;
  margin-top: 0.5rem;
  margin-bottom: 0rem;
  margin-left:0px;
}

.ui-recommendation-header .title {
  margin: 0;
}
.headerIcon{
  font-size: 1rem;
}

@media (max-width: 768px) {
  .ui-recommendation-header {
    padding: 0.5rem; /* reduce padding on mobile */
  }

  .ui-recommendation-header .ant-typography {
    font-size: 16px !important; /* smaller font */
  }
  .headerIcon{
    font-size: 1rem!important;
  }


  .ui-recommendation-header .subtitle {
    font-size: 12px !important;
  }
}

@media (min-width: 1100px){
  .texting-joy-button{
    display: none;
}
}`, "",{"version":3,"sources":["webpack://./src/components/common/UiRecommendationHeader.css"],"names":[],"mappings":"AAAA,iCAAiC;AACjC;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;AACA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,eAAe,EAAE,6BAA6B;EAChD;;EAEA;IACE,0BAA0B,EAAE,iBAAiB;EAC/C;EACA;IACE,yBAAyB;EAC3B;;;EAGA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,aAAa;AACjB;AACA","sourcesContent":["/* ui-recommendation-header.css */\n.ant-typography{\n  font-family: \"Poppins\" !important;\n}\n\n.ui-recommendation-header {\n  display: flex;\n  align-items: center;\n  padding: 0.5rem 1rem;\n  border-radius: 8px 8px 0px 0px;\n  margin-top: 0.5rem;\n  margin-bottom: 0rem;\n  margin-left:0px;\n}\n\n.ui-recommendation-header .title {\n  margin: 0;\n}\n.headerIcon{\n  font-size: 1rem;\n}\n\n@media (max-width: 768px) {\n  .ui-recommendation-header {\n    padding: 0.5rem; /* reduce padding on mobile */\n  }\n\n  .ui-recommendation-header .ant-typography {\n    font-size: 16px !important; /* smaller font */\n  }\n  .headerIcon{\n    font-size: 1rem!important;\n  }\n\n\n  .ui-recommendation-header .subtitle {\n    font-size: 12px !important;\n  }\n}\n\n@media (min-width: 1100px){\n  .texting-joy-button{\n    display: none;\n}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
